export default "__VITE_ASSET__UjaQAUdG__"